// extracted by mini-css-extract-plugin
export default {"processTypeView":"ProcessTypeView_processTypeView__l9IiC","expandedProcessList":"ProcessTypeView_expandedProcessList__Uh-8w"};